<div class="transparent-modal absolute-content">
  <div class="modal-header" [ngClass]="iconTypeLayoutClass()">
    <button class="close" aria-label="Close" (click)="closeModal()" [ngClass]="iconCustomLayoutClass()">
      <img src="/assets/images/bt-close.svg" width="28px" height="28px" />
    </button>
  </div>

  <div class="modal-body" *ngIf="exists(iframeSrc)">
    <iframe [src]="iframeSrc" scrolling="yes" (load)="checkToClose()"></iframe>
  </div>
</div>
